<template>
  <div id="app" class="bg-white">
    <NavBar
      v-if="$route.path !== '/'"
      :loggedOutPaths="loggedOutPaths"
      :backgroundColor="navBarBackgroundColor"
      :textColor="navBarTextColor"
      fixed
    />
    <transition
      name="slideLeftFade"
      mode="out-in"
    >
      <router-view :key="$route.path" />
    </transition>
  </div>
</template>

<script>
// @ is an alias to /src
import NavBar from '@/components/NavBar.vue'
export default {
  name: 'app',
  components: {
    NavBar
  },
  data () {
    return {
      loggedOutPaths: [
        '*',
        '!/',
        '!/home',
        '!/project/:id',
        '!/journalentry/:id'
      ]
    }
  },
  computed: {
    navBarBackgroundColor () {
      var toReturn = 'bg-transparent'
      if (this.$route.path === '/home') toReturn = 'bg-transparent'
      else if (this.$route.path === '/projects') toReturn = 'bg-transparent'
      else if (this.$route.path.includes('/project/')) toReturn = 'bg-white'
      else if (this.$route.path === '/practice') toReturn = 'bg-white'
      else if (this.$route.path.includes('/journalentry/')) toReturn = 'bg-white'
      else if (this.$route.path === '/contact') toReturn = 'bg-white'
      return toReturn
    },
    navBarTextColor () {
      var toReturn = 'text-white'
      if (this.$route.path === '/home') toReturn = 'text-white'
      else if (this.$route.path === '/projects') toReturn = 'text-white'
      else if (this.$route.path.includes('/project/')) toReturn = 'text-black'
      else if (this.$route.path === '/practice') toReturn = 'text-black'
      else if (this.$route.path.includes('/journalentry/')) toReturn = 'text-black'
      else if (this.$route.path === '/contact') toReturn = 'text-black'
      return toReturn
    }
  },
  mounted () {
  },
  created () {
    // if (this.$route.path === '/home') this.$router.replace('/')
    if (this.$route.path !== '/') this.$router.replace('/')
  }
}
</script>

<style lang="scss">

  // FADE IN AND OUT
  .slideContent-enter-active {
    transition: all 1.5s ease;
  }
  .slideContent-leave-active {
    transition: all 0s ease;
  }
  .slideContent-enter {
    opacity: 0;
  }
  .slideContent-leave-to {
    opacity: 0;
  }

  // FADE IN AND OUT
  .fade-enter-active {
    transition: opacity 2s;
  }
  .fade-leave-active {
    transition: opacity 2s;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  // SLIDE OUT LEFT
  .slideLeft-enter-active, .slideLeft-leave-active {
    transition: transform 1s;
  }

  .slideLeft-enter, .slideLeft-leave-to {
    transform: translateX(-100%);
  }

  .slideLeft-enter-to, .slideLeft-leave {
    transform: translateX(0);
  }

  // SLIDE LEFT OUT AND FADE IN
  .slideLeftFade-enter-active {
    transition: all 1s ease;
  }
  .slideLeftFade-leave-active {
    transition: all 1s ease;
  }
  .slideLeftFade-enter {
    transform: translateY(0%);
    opacity: 0;
  }
  .slideLeftFade-leave-to {
    transform: translateX(-100%);
  }

  // FADE IN AND OUT
  .transHomeText-enter-active {
    transition: opacity 2s;
    transition-delay: 1000ms;
  }
  .transHomeText-leave-active {
    transition: opacity 2s;
    transition-delay: 0000ms;
  }
  .transHomeText-enter, .transHomeText-leave-to {
    opacity: 0;
  }

  // FADE IN AND OUT
  .transHomeVideo-enter-active {
    transition: opacity 2s;
    transition-delay: 1000ms;
  }
  .transHomeVideo-leave-active {
    transition: opacity 2s;
    transition-delay: 1000ms;
  }
  .transHomeVideo-enter, .transHomeVideo-leave-to {
    opacity: 0;
  }

  // SLIDE UP OUT AND FADE IN
  .transHomeHeading-enter-active {
    transition: all 2s ease;
    transition-delay: 0000ms;
  }
  .transHomeHeading-leave-active {
    transition: all 2s ease;
    transition-delay: 1500ms;
  }
  .transHomeHeading-enter {
    transform: translateY(0px);
    opacity: 0;
  }
  .transHomeHeading-leave-to {
    transform: translateY(-8000px);
  }

  .transHomeHeadingMobile-enter-active {
    transition: all 1s ease;
    transition-delay: 0000ms;
  }
  .transHomeHeadingMobile-leave-active {
    transition: all 1s ease;
    transition-delay: 1000ms;
  }
  .transHomeHeadingMobile-enter {
    opacity: 0;
  }
  .transHomeHeadingMobile-leave-to {
    opacity: 0;
  }

</style>
